import type { FeatureAccessStatus } from 'v2/interfaces/featureAccess';

export type Props = {
  transferAccessData: FeatureAccessStatus;
  refetchFeatureAccessData: () => void;
  isLoading: boolean;
  modalTransferIsOpen: boolean;
  hasValueToAnticipate: boolean;
  fetchData: () => void;
  handleToggleTransferModal: () => void;
  handleToggleAnticipateModal: () => void;
};

export type TransferByInvoice = {
  approx_amount: number;
  status: boolean;
  transfer_key: string;
};

export const MESSAGE_LAST_TRANSFER_CANCELLED =
  'Sua última transferência foi cancelada. Verifique o motivo em Histórico de Transferências.';
